<template lang="pug">
.parametros-padrao-formulario
    BaseHeader(
        :titulo='$t("configuracaoParametros.formulario.titulo.padrao")',
        voltarPara
    )
    .parametros-padrao-formulario__container
        .parametros-padrao-formulario__titulo
            h3 {{ obterTituloFormulario() }}
        el-form.parametros-padrao-formulario__form(
            label-position='top',
            size='default',
            :model='configuracao',
            :rules='regras',
            :hide-required-asterisk='true',
            ref='parametrosPadraoFormularioRef'
        )
            el-form-item.required(
                :label='$t("configuracaoParametros.formulario.campoDistanciaRaioKm")',
                prop='distanciaRaioKm'
            )
                el-input(
                    type='number',
                    v-model='configuracao.distanciaRaioKm',
                    :placeholder='$t("configuracaoParametros.formulario.placeholderDistanciaRaioKm")',
                    @keydown='handleKeydownInputNumber'
                )
            el-form-item(
                :label='$t("configuracaoParametros.formulario.campoPorExcCapProdutiva")',
                prop='percentualCapacidadeProdutiva'
            )
                el-input(
                    type='number',
                    v-model='configuracao.percentualCapacidadeProdutiva',
                    :placeholder='$t("configuracaoParametros.formulario.placeholderCampoPorExcCapProdutiva")',
                    disabled,
                    @keydown='handleKeydownInputNumber'
                )
        .parametros-padrao-formulario__footer
            el-button(@click='voltarConfiguracao')
                i.mdi.mdi-arrow-left
                span {{ $t('configuracaoParametros.formulario.butaoVoltar') }}
            el-button(type='primary', @click='submeterParametros')
                span {{ $t('configuracaoParametros.formulario.butaoSalvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/services/ConfiguracaoRastreabilidadeService';
import { handleKeydownInputNumber } from '@/views/contratos-originacao/parametros/utils';
import {
    cadastrarParametros,
    editarParametros
} from '@/views/contratos-originacao/parametros/services/configuracaoPadraoService';
import regras from '@/views/contratos-originacao/parametros/utils/assets/regrasFormularioPadrao';

export default {
    name: 'ParametrosEstadoFormulario',
    components: {
        BaseHeader: () => import('@/components/BaseHeader')
    },
    data() {
        return {
            regras,
            configuracao: {
                id: null,
                distanciaRaioKm: null,
                percentualCapacidadeProdutiva: 15
            }
        };
    },
    mounted() {
        this.buscarConfiguracaoPadrao();
    },
    computed: {
        formRef() {
            return this.$refs.parametrosPadraoFormularioRef;
        }
    },
    methods: {
        handleKeydownInputNumber,

        obterTituloFormulario() {
            return this.$route.params?.idConfiguracaoRastreabilidade
                ? this.$t(
                      'configuracaoParametros.formulario.tituloFormularioCadastro.padrao'
                  )
                : this.$t(
                      'configuracaoParametros.formulario.tituloFormularioCadastro.padrao'
                  );
        },
        voltarConfiguracao() {
            this.$router.push({ name: 'ConfiguracaoParametros' });
        },
        buscarConfiguracaoPadrao() {
            const id = this.$route.params?.idConfiguracaoRastreabilidade;

            return services
                .buscarConfiguracaoRastreabilidadePadrao()
                .then(({ data }) => {
                    if (data) {
                        this.configuracao.id = id;
                        this.configuracao.distanciaRaioKm =
                            data.distanciaRaioKm;
                        this.configuracao.percentualCapacidadeProdutiva =
                            data.percentualCapacidadeProdutiva;
                    }
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroBucaConfiguracaoPadrao'
                        )
                    );
                });
        },
        cadastrarParametros() {
            cadastrarParametros(this.configuracao).then(() => {
                this.$notify.success(
                    this.$t(
                        'configuracaoParametros.sucesso.sucessoCadastrarDados'
                    )
                );
                this.voltarConfiguracao();
            });
        },
        editarParametros() {
            editarParametros(this.configuracao).then(() => {
                this.$notify.success(
                    this.$t('configuracaoParametros.sucesso.sucessoEditarDados')
                );
                this.voltarConfiguracao();
            });
        },
        submeterParametros() {
            this.formRef.validate(valid => {
                if (valid) {
                    if (this.configuracao.id) {
                        this.editarParametros();
                    } else {
                        this.cadastrarParametros();
                    }
                } else {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroFormularioInvalido'
                        )
                    );
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss">
.parametros-padrao-formulario {
    &__container {
        margin: 20px;
    }
    &__titulo {
        margin-top: 20px;
    }
    &__form {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 20px;
        padding: 20px;
        background-color: var(--white);
        border-radius: $default-border-radius;
        @include default-box-shadow();
    }
    &__info {
        color: var(--gray);
    }
    &__footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .el-form-item {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 4px;
        &.required > .el-form-item__label {
            &::after {
                content: '*';
                margin-left: 2px;
                color: red;
            }
        }
        &__label {
            line-height: 1;
        }
        .el-input {
            width: 100%;
            height: 42px;
            outline: none;
            border: 1px solid $default-border-color;
            border-radius: $default-border-radius;
            &:hover,
            &:focus {
                border: 1px solid $primary;
            }
            & input {
                color: var(--primary) !important;
                outline: none;
                border: none;
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }
    .el-button {
        &--primary {
            &:focus {
                color: var(--white);
            }
        }
        &--default {
            background-color: transparent;
            color: var(--primary);
            border: 1px solid var(--primary);
            &:hover {
                background-color: var(--primary);
                color: var(--white);
            }
        }
    }
}
</style>
